// Shared pure helpers (no React).

import { toLocale } from '@common/i18n';

import { ACCEPT_EXTENSIONS, BYTES_PER_MB, MAX_FILE_MB } from './consts';

const { cdnBaseUrl = '' } = window.okGlobal || {};

// CDN URL for a recruit asset, shared by top / submit pages.
export const recruitImageUrl = (name) =>
  `${cdnBaseUrl}/cdn/assets/imgs/recruit/${name}`;

export const inspectFile = (file) => {
  const isFile = file instanceof File;
  const sizeMB = isFile ? file.size / BYTES_PER_MB : 0;
  const name = isFile ? file.name.toLowerCase() : '';
  return {
    isFile,
    sizeMB,
    formatValid: !isFile || ACCEPT_EXTENSIONS.some((ext) => name.endsWith(ext)),
    sizeValid: !isFile || sizeMB <= MAX_FILE_MB,
  };
};

// Collect upload error messages for one file (required + format + size).
export const buildFileErrors = (
  check,
  { includeRequired = false, requiredSatisfied = true } = {}
) => {
  const messages = [];
  if (includeRequired && !requiredSatisfied) {
    messages.push(toLocale('recruit_upload_resume_required'));
  }
  if (!check.formatValid) {
    messages.push(toLocale('recruit_upload_format_invalid'));
  }
  if (!check.sizeValid) {
    messages.push(toLocale('recruit_upload_size_invalid'));
  }
  return messages;
};
